import React from 'react'
import styled from '@emotion/styled'
import { H1, P1 } from 'src/components/Typography'

import Card from 'src/components/Card'

type SummaryCardProps = {
  label: React.ReactNode
  amount: React.ReactNode
  type?: 'default' | 'dark'
  height?: number
  width?: number
}

const SummaryCard = ({
  label,
  amount,
  type = 'default',
  height = 91,
  width = 230
}: SummaryCardProps) => {
  const StyledSummaryCard = styled(Card)`
    width: ${width}px;
    min-height: ${height}px;
    padding: 3px;
    border-radius: 5px;
  `

  return (
    <StyledSummaryCard type={type}>
      <P1 style={{ marginBottom: '5px' }}>{label}</P1>
      <H1>{amount}</H1>
    </StyledSummaryCard>
  )
}

export default SummaryCard
